<template lang="html">
  <table>
    <tbody>
      <tr>
        <td>
          <ruler> </ruler>
        </td>
        <td>
          <ticker></ticker>
          <timeline-container></timeline-container>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import Ticker from './Ticker'
import TimelineContainer from './TimelineContainer'
import Ruler from './Ruler'
export default {
  components: {
    'ticker': Ticker,
    'ruler': Ruler,
    'timeline-container': TimelineContainer
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// TimetableBody.vue?a17f4198